<div *ngIf="mrnData" class="flex flex--row flex--nowrap flex--left flex--middle">
  <div
    id="{{ id }}-value"
    class="text-ellipsis u-pr----"
    [tooltip]=" (mrnData.domainIdentifier).toLowerCase() === 'unavailable' ? ('label.unavailable' | translate) : mrnData.domainIdentifier "
    [overflowOnly]="true"
    [ngClass]="
      mrnData.identifierCountDisplayStatus ? 'item-detail-metadata-value' : 'item-detail-metadata-value-single-domain'
    "
  >
  {{ (mrnData.domainIdentifier).toLowerCase() === 'unavailable' ? ('label.unavailable' | translate) : mrnData.domainIdentifier }}
  </div>
  <span id="{{ id }}-counter" class="badge badge--notification" *ngIf="mrnData.identifierCountDisplayStatus">
    <ng-container *ngIf="showTooltip; else showOnlyBadge">
      <wfm-popover
        [background]="'default'"
        [position]="'bottom'"
        [pointerPosition]="'center'"
        [manualTrigger]="true"
        [open]="popoverOpen"
      >
        <span slot="trigger">
          <span
            id="popover-trigger"
            (mouseover)="popoverOpen = true"
            (mouseleave)="leavePopoverBadge()"
            class="badge__count badge__count--large u-m0 badge--info-5 mrn-counter-badge"
          >
            {{ mrnData.identifierListLength }}
          </span>
        </span>
        <div (mouseover)="popoverOnTooltip = true" (mouseleave)="leavePopoverTooltip()" id="popover-message" class="popover-data">
          <div>
            <div class="patient-info-identifier-header">{{ 'patientModule.primaryDomainLabel' | translate }}</div>
            <div class="domain-identifier-name">{{ mrnData.domainIdentifierName }}</div>
            <div class="mrn-data">
              <span> {{ 'patientModule.mrnLabel' | translate }}</span>
              <span>&nbsp;&nbsp;{{ mrnData.domainIdentifier }}</span>
            </div>
          </div>
          <span layout="row"><hr flex /></span>
          <div class="other-institution-domains" wfmScrollbar>
            <div class="patient-info-identifier-header">{{ 'patientModule.otherDomainsLabel' | translate }}</div>
            <div *ngFor="let domain of mrnData.otherDomainIdentifierList">
              <div class="domain-identifier-name">{{ domain.system }}</div>
              <div class="mrn-data">
                <span> {{ getDomainLabel(domain) }}</span>
                <span>&nbsp;&nbsp;{{ getDomainValue(domain) }}</span>
              </div>
            </div>
          </div>
        </div>
      </wfm-popover>
    </ng-container>
    <ng-template #showOnlyBadge>
      <span class="badge__count badge__count--large u-m0 badge--info-5 mrn-counter-badge">
        {{ mrnData.identifierListLength }}
      </span>
    </ng-template>
  </span>
</div>
